export default {
  inbox: ({ inbox }) => inbox,
  selectedEmail: ({ selectedEmail }) => selectedEmail,
  newMessagesCount: ({ newMessagesCount }) => newMessagesCount,
};
